import React from 'react';
import { Link } from 'react-router-dom';

// Standalone Navbar for JoSmart Academy (detached app)
// No dependencies on main JoSmartTech site (LanguageContext, NotificationBell removed)
export default function Navbar() {
  return (
    <nav
      data-testid="academy-navbar"
      className="w-full bg-white/90 backdrop-blur border-b border-gray-200 sticky top-0 z-40"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="academy-logo-link">
          <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
            JoSmart Academy
          </span>
        </Link>
        <div className="flex items-center gap-4 text-sm">
          <a
            href="https://josmarttech.net"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 hover:text-blue-600"
            data-testid="academy-main-site-link"
          >
            ← JoSmartTech
          </a>
        </div>
      </div>
    </nav>
  );
}

export { Navbar };
